<h1 class="cooper margin-bottom">Importer des collaborateurs</h1>
<div class="column gap">

  <app-info>Assurez-vous que votre fichier contiennent quatre colonnes Prenom, Nom, Email et Genre. Dans le cas contraire le fichier sera ignoré.</app-info>
  <app-upload-file  [outline]="true" (updateFile)="selectFile($event)"></app-upload-file>
  <a href="assets/csv/import-example.csv" class="row gap"><app-icon type="upload"/>  Exemple de fichier</a>
  <app-button [disabled]="!file" (click)="validate()">Valider</app-button>
</div>
